import React, { useState } from "react"
import { Row, Col, Card, Form, CardSubtitle, Alert } from "reactstrap"
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import { useLoading } from "helpers/custom_hooks"
import { displayMessage } from "helpers/misc_helpers"
import _ from "lodash"
import MessageModal from "components/Common/MessageModal"
import { UpdateQCRequest, UploadQCAttachment } from "helpers/backend_helper"
import NumberInput from "components/Common/NumberInput"

const QCReportFileDrop = ({ entry, reload }) => {
  const setLoading = useLoading()
  const [error, setError] = useState()
  const [reportStatus, setReportStatus] = useState("")
  const [price, setPrice] = useState(0)
  const [recommendation, setRecommendation] = useState("")
  const [selectedFiles, setselectedFiles] = useState([])
  const [successModal, setSuccessModal] = useState(false)

  const handleFileUpload = files => {
    const file = files[0]
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })

    const reader = new FileReader()

    reader.readAsArrayBuffer(file)
    setselectedFiles(files)
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const handleSave = async () => {
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("file", selectedFiles[0])
      formData.append("id", entry?.id)
      const result = await UploadQCAttachment(formData)
      entry.reportFileURL = result?.url
      entry.dateReportUploaded = new Date()
      entry.dateReviewDone = new Date()
      entry.recommendation = recommendation
      entry.reportStatus = reportStatus
      if (entry?.additionalTests) {
        entry.dateAccepted = null
      } else entry.additionalCosts = price
      entry.statusIndex++

      await UpdateQCRequest(entry)

      setSuccessModal(true)
    } catch (error) {
      error?.response?.status == 400
        ? displayMessage(error.response.data, setError)
        : displayMessage("An unexpected error happened!", setError)
      console.log(error)
    }

    setLoading(false)
  }

  return (
    <>
      <div className="px-3">
        {error && <Alert color="danger">{error}</Alert>}
        <Row>
          <h6 className="card-title">Report Upload</h6>
          <CardSubtitle className="mb-3">
            Please upload the report file here. (Only PDF files are allowed)
            {entry?.reportFileURL && (
              <>
                <br />
                Download the first report{" "}
                <a href={entry?.reportFileURL} target="_blank" rel="noreferrer">
                  here.
                </a>
              </>
            )}
          </CardSubtitle>
        </Row>

        <Form>
          <Dropzone
            onDrop={acceptedFiles => {
              handleFileUpload(acceptedFiles)
            }}
            accept={{
              "application/pdf": [],
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <div className="dropzone">
                <div className="dz-message needsclick mt-2" {...getRootProps()}>
                  <input {...getInputProps()} />
                  <div className="mb-3">
                    <i className="display-4 text-muted bx bxs-cloud-upload" />
                  </div>
                  <h4>Drop files here or click to upload.</h4>
                </div>
              </div>
            )}
          </Dropzone>
          <div className="dropzone-previews mt-3" id="file-previews">
            {selectedFiles.map((f, i) => {
              return (
                <Card
                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                  key={i + "-file"}
                >
                  <div className="p-2">
                    <Row className="align-items-center">
                      <Col className="col-auto">
                        <i className="mdi mdi-file-pdf font-size-24 font-primary text-success" />
                      </Col>
                      <Col className="col-auto me-4 ">
                        <Link to="#" className="text-muted font-weight-bold">
                          {f.name}
                        </Link>
                        <p className="mb-0">
                          <strong>{f.formattedSize}</strong>
                        </p>
                      </Col>
                      <Col className="ms-auto text-end">
                        <i
                          className="bx bx-x cursor-pointer font-size-20 text-danger"
                          onClick={() => setselectedFiles([])}
                        />
                      </Col>
                    </Row>
                  </div>
                </Card>
              )
            })}
          </div>

          <Row>
            <Col>
              <h5 className="mt-3 mb-3">Status:</h5>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="reportStatus"
                  id="reportStatus1"
                  value="acceptable"
                  onChange={() => setReportStatus("acceptable")}
                />
                <label className="form-check-label" htmlFor={"reportStatus1"}>
                  Acceptable
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  value="far"
                  name="reportStatus"
                  id="reportStatus2"
                  onChange={() => setReportStatus("far")}
                />
                <label className="form-check-label" htmlFor={"reportStatus2"}>
                  Further Analysis recommended
                </label>
              </div>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  value="fail"
                  name="reportStatus"
                  id="reportStatus3"
                  onChange={() => setReportStatus("fail")}
                />
                <label className="form-check-label" htmlFor={"reportStatus3"}>
                  Fail
                </label>
              </div>
            </Col>
          </Row>

          {!entry?.additionalTests && (
            <Row className="mb-3">
              <Col style={{ maxWidth: "320px", minWidth: "150px" }}>
                <h5 className="mt-3 mb-3 ms-0 ps-0">
                  Additional costs (excl. VAT - {entry.currency}):
                </h5>

                <NumberInput initial="" onChange={setPrice} />
              </Col>
            </Row>
          )}

          <Row className="mb-3">
            <Col>
              <h5 className="mt-3 mb-3 ms-0 ps-0">Recommendation:</h5>
              <textarea
                className="form-control"
                rows="7"
                onChange={e => setRecommendation(e.target.value)}
              />
            </Col>
          </Row>

          <button
            type="button"
            onClick={handleSave}
            disabled={selectedFiles.length == 0 || !reportStatus}
            className="btn btn-primary ms-2 mt-3"
          >
            Save Report
          </button>
        </Form>
      </div>
      <MessageModal
        show={successModal}
        displayMessage={"Upload successful!"}
        onCloseClick={reload}
        color="success"
        icon="bx bx-check"
      />
    </>
  )
}

export default QCReportFileDrop
